module.exports = __webpack_public_path__ + "static/service-5-c6ceadfc4f1b971c1e95c766e5867f46.jpg";